import { render } from "./InvoiceDownload.vue?vue&type=template&id=5c2ff5da&scoped=true"
import script from "./InvoiceDownload.vue?vue&type=script&lang=js"
export * from "./InvoiceDownload.vue?vue&type=script&lang=js"

import "./InvoiceDownload.vue?vue&type=style&index=0&id=5c2ff5da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2ff5da"]])

export default __exports__